import { defineComponent, ref, watch, computed, nextTick, onMounted, onUnmounted, } from '@vue/composition-api';
import { debounce } from 'lodash';
import FloatingPanel from 'components/widgets/FloatingPanel/FloatingPanel.vue';
export default defineComponent({
    components: { FloatingPanel },
    props: {
        getParentElement: {
            type: Function,
            default: () => undefined,
        }
    },
    setup(props, { emit, slots }) {
        const visible = ref(false);
        const xPos = ref(0);
        const yPos = ref(0);
        const hasContent = computed(() => 'default' in slots);
        const onClick = (event) => {
            visible.value = !visible.value;
            if (!visible.value)
                return;
            const parent = props.getParentElement();
            if (parent === undefined)
                return;
            xPos.value = event.clientX;
            yPos.value = event.clientY;
        };
        const clickedOutside = (e) => {
            const parent = props.getParentElement();
            const validTarget = (e.target instanceof HTMLElement) || (e.target instanceof SVGElement);
            if (parent === undefined || !validTarget)
                return;
            const contained = parent.contains(e.target);
            if (!contained) {
                visible.value = false;
            }
        };
        const handleScroll = debounce(() => {
            if (visible.value) {
                visible.value = false;
                emit('self-close');
            }
        }, 250, { 'leading': true });
        const addParentClickHandler = () => {
            props.getParentElement()?.addEventListener('click', onClick);
        };
        watch(() => props.getParentElement, addParentClickHandler);
        onMounted(() => {
            nextTick(addParentClickHandler);
            if (typeof window !== 'undefined') {
                document.addEventListener('wheel', handleScroll);
            }
        });
        onUnmounted(() => {
            props.getParentElement()?.removeEventListener('click', onClick);
            if (typeof window !== 'undefined') {
                document.removeEventListener('click', clickedOutside);
                document.removeEventListener('wheel', handleScroll);
            }
        });
        if (typeof window !== 'undefined') {
            document.addEventListener('click', clickedOutside);
        }
        return {
            visible,
            xPos,
            yPos,
            hasContent,
        };
    },
});
